import { render, staticRenderFns } from "./IntegrationPanel.vue?vue&type=template&id=c3b63aa4&scoped=true&"
import script from "./IntegrationPanel.vue?vue&type=script&lang=ts&"
export * from "./IntegrationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationPanel.vue?vue&type=style&index=0&id=c3b63aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b63aa4",
  null
  
)

export default component.exports